import React from "react";
import { Icon } from "./Icon";

interface CreditCardProps {
  size?: number;
  className?: string;
  viewBox?: string;
  color?: string;
}

export const PixPay2B: React.FC<CreditCardProps> = ({
  size = 16,
  className = "",
  viewBox = "0 0 16 16",
  color,
}) => {
  return (
    <Icon size={size} className={className} color={color} viewBox={viewBox}>
      <path d="M7.6191 9.06723C7.77434 8.91199 8.04171 8.91199 8.19695 9.06723L10.4106 11.2809C10.8189 11.6891 11.3622 11.9134 11.9372 11.9134H12.3713L9.57977 14.7049C8.70868 15.553 7.29424 15.553 6.42315 14.7049L3.62013 11.9047H3.8875C4.46248 11.9047 5.00583 11.6805 5.41406 11.2723L7.6191 9.06723ZM8.19695 6.95132C8.01296 7.10943 7.77722 7.11231 7.6191 6.95132L5.41406 4.74628C5.00583 4.31217 4.46248 4.1138 3.8875 4.1138H3.62013L6.42027 1.31251C7.29424 0.4401 8.70868 0.4401 9.57977 1.31251L12.3742 4.10518H11.9372C11.3622 4.10518 10.8189 4.32942 10.4106 4.73765L8.19695 6.95132ZM3.8875 4.76065C4.28423 4.76065 4.64934 4.92165 4.95408 5.20338L7.15912 7.40842C7.36611 7.58954 7.63635 7.71891 7.90946 7.71891C8.17971 7.71891 8.44994 7.58954 8.65694 7.40842L10.8706 5.19476C11.1523 4.91589 11.5404 4.7549 11.9372 4.7549H13.021L14.6971 6.43096C15.5682 7.30205 15.5682 8.7165 14.6971 9.58759L13.021 11.2636H11.9372C11.5404 11.2636 11.1523 11.1027 10.8706 10.8209L8.65694 8.60725C8.25733 8.20764 7.55873 8.20764 7.15912 8.61013L4.95408 10.8123C4.64934 11.094 4.28423 11.255 3.8875 11.255H2.97271L1.3047 9.58759C0.432287 8.7165 0.432287 7.30205 1.3047 6.43096L2.97271 4.76065H3.8875Z" />
    </Icon>
  );
};
